module.exports = __webpack_public_path__ + "static/noted-7d049292d75a46668be6cc84d38b49d8.gif";